import { useToast } from "vue-toastification";

export default {
    data() {
        return {
            // Overrides options set in app.js
            defalutToastOptions: {
                position: "top-right",
                timeout: 10000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false,
                //
                toastClassName: "titan-toast",
            },
            toast: useToast(),
        };
    },
    computed: {
        toastNotification() {
            return this.$page.props.flash;
        },
    },
    watch: {
        toastNotification(flash) {
            if (flash) {
                if (flash.success) {
                    this.toast.success(flash.success, this.defalutToastOptions);
                }

                if (flash.error) {
                    this.toast.error(flash.error, this.defalutToastOptions);
                }

                if (flash.info) {
                    this.toast.info(flash.info, this.defalutToastOptions);
                }

                if (flash.message) {
                    this.toast.info(flash.message, this.defalutToastOptions);
                }

                if (flash.warning) {
                    this.toast.warning(flash.warning, this.defalutToastOptions);
                }
            }
        },
    },
};
